<div class="section-list card">
    <div *ngIf="!ismodal" class="card-header">
        <nav class="navbar navbar-expand-sm navbar-light navbar-section-header justify-content-between section-header">
            <span class="navbar-brand mb-0 h1"><i class="fas fa-list"></i> Supervisions</span><span class="badge badge-primary">{{listFiltered.length}}</span>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div class="ml-auto d-flex justify-content-end">

                    <ul class="nav navbar-nav ml-auto">
                        <li class="nav-item" *ngIf="showSiteCol" style="max-width: 200px;">
                            <frms-list-filter #filterbystatus [mylist]="statusList" [fieldId]="'id'" [selectAllCheked]="true" 
                                [myplaceholder]="'Filter by Status'" (onItemSelected)="filterbystatusOnItemSelectedHandler($event)"></frms-list-filter>
                        </li>                        
                        <li class="nav-item" *ngIf="showSiteCol" style="max-width: 200px;">
                            <app-site-filter #filterbysite [automaticLoad]="false" [mylist]="siteListForFilter"
                                [myplaceholder]="'Filter by Site'"></app-site-filter>
                        </li>
                        <li *permusr="controlEnum.BTN_SUPERVISION_EDIT" class="nav-item">
                            <a class="nav-link" role="button" (click)="newsupervision(site);false">
                                <i class="far fa-plus-square"></i> New Supervision
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" role="button" (click)="refresh();false">
                                <i class="fas fa-sync"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
    <div class="card-body nopadding">
        <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
        <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>

        <div class="app-table pointer">
            <p-table [value]="listFiltered" sortMode="multiple" [scrollHeight]="'calc(100vh - 158px)'" [scrollable]="true" >
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngIf="ui_showCompany && !siteMode" [pSortableColumn]="'company.name'"
                            class="td-companyname">Company
                            <p-sortIcon [field]="'company.name'"></p-sortIcon>
                        </th>
                        <th *ngIf="!siteMode" [pSortableColumn]="'site.name'" class="td-name">Site
                            <p-sortIcon [field]="'site.name'"></p-sortIcon>
                        </th>                        
                        <th [pSortableColumn]="'name'" class="td-name">Supervision
                            <p-sortIcon [field]="'name'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'date'" class="td-dates" matTooltip="Date of supervision">Scheduled Date
                            <p-sortIcon [field]="'date'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'info.status'" class="td-status text-center">Status
                            <p-sortIcon [field]="'info.status'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'info.errorsDetected'" class="td-errors">Errors
                            <p-sortIcon [field]="'info.errorsDetected'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'info.powerLost'" class="td-powerlost"
                            matTooltip="Lost power based on the number of errors and an average of 10% per panel.">Power
                            Lost
                            <p-sortIcon [field]="'info.powerLost'"></p-sortIcon>
                        </th>
                        <th [pSortableColumn]="'info.updating_date'" class="td-dates">Last update
                            <p-sortIcon [field]="'info.updating_date'"></p-sortIcon>
                        </th>
                        <th class="td-actions">

                        </th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row >
                    <tr (click)="openitem(row)">
                        <td *ngIf="ui_showCompany && !siteMode" class="td-companyname">{{row.company?.name}}</td>
                        
                        <td *ngIf="!siteMode" class="td-name">
                            <a (click)="gotoSite($event,row.site)"
                                >{{row.site?.name}}</a>
                        </td>
                        <td class="td-name">{{row.name}}</td>
                        <td class="td-dates">{{row.info.supervisionDate | date:'dd-MM-yyyy' }}</td>
                        <td class="td-status" (click)="$event.stopPropagation()">
                            <app-superv-status #icostatus [status]="row?.info?.status" [supervision]="row"></app-superv-status>
                        </td>
                        <td class="td-errors">{{row.info.errorsDetected }}</td>
                        <td class="td-powerlost"><span
                                matTooltip="Estimated power lost">{{row.info?.powerLost| watts}}</span>
                        </td>

                        <!--                         <td class="td-dates">
                            {{row.info?.validated | date:'dd-MM-yyyy' }}
                        </td> -->
                        <td class="td-datel">{{row.info?.updating_date | date:'dd-MM-yyyy HH:mm' }}</td>
                        <td class="td-actions" (click)="$event.stopPropagation()">
                            <div *permusr="controlEnum.BTN_SUPERVISION_EDIT" class="td-actions text-right">
                                <button type="button" class="btn btn-sm btn-outline-secondary"
                                    [matMenuTriggerFor]="menu">
                                    <i class="fas fa-ellipsis-v"></i>
                                </button>
                                <mat-menu #menu="matMenu" class="">
                                    <div mat-menu-item *ngIf="statusCanBeChanged">
                                        <a class="dropdown-item" (click)="supervisionChangeStatus(row,icostatus)" matTooltip="Change Status of supervision">
                                            <i class="fas fa-exchange-alt"></i> Change Status
                                        </a>
                                    </div> 
                                    <div mat-menu-item *ngIf="uiisdeletable(row)">
                                        <a class="dropdown-item text-danger" (click)="supervisionDelete(row)">
                                            <i class="far fa-trash-alt"></i> Delete
                                        </a>
                                    </div>
                                </mat-menu>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>